import React from 'react';
import {
    Stack,
} from '@shopify/polaris';
import AttributeFilterComponent from './AttributeFilterComponent';
import CustomerAddressesFilter from './CustomerAddressesFilter';
import ProductConditionItem from '../ProductConditionItem';

class CustomerConditionComponent extends React.Component {

    state = {};

    render() {

        let conditionElements = this.props.filters.map((filter, index) => {

            let filterComponent = null;

            if (filter.body.filterType === "AttributeFilter") {
                let distinct = this.props.distinctValues[filter.body.attributePath];

                if (distinct == null) {
                    distinct = [];
                }

                filterComponent = <AttributeFilterComponent
                    allowedValues={filter.allowedValues}
                    attributeIsOptional={filter.attributeIsOptional}
                    attributeType={filter.attributeType}
                    distinctValues={distinct}
                    onRequestAttributeValues={this.props.onRequestAttributeValues}
                    onConditionOperatorChange={(newValue) => this.props.onFilterConditionOperatorChange(filter.id, newValue)}
                    onConditionValueChange={(newValue) => this.props.onFilterConditionValueChange(filter.id, newValue)}
                    conditionType={filter.body.conditionType}
                    conditionOperator={filter.body.conditionOperator}
                    conditionValue={filter.body.conditionValue} />
            }

            if (filter.body.filterType === "CustomerAddressesFilter") {

                filterComponent = <CustomerAddressesFilter
                    onRequestAttributeValues={this.props.onRequestAttributeValues}
                    onConditionOperatorChange={(newValue) => this.props.onFilterConditionOperatorChange(filter.id, newValue)}
                    onConditionValueChange={(newValue) => this.props.onFilterConditionValueChange(filter.id, newValue)}
                    onRequirementChange={(newValue) => this.props.onFilterRequirementChange(filter.id, newValue)}
                    itemsFilter={filter.itemsFilter}
                    requirement={filter.body.requirement} />
            }

            return <ProductConditionItem
                key={filter.id}
                number={index + 1}
                error={filter.error}
                onDelete={() => this.props.onFilterDelete(index)}>
                <Stack alignment="center" spacing="tight">
                    <Stack.Item>
                        {filter.getLabel()}
                    </Stack.Item>
                    <Stack.Item fill>
                        {filterComponent}
                    </Stack.Item>
                </Stack>
            </ProductConditionItem>
        }
        );

        return (
            <React.Fragment>
                {conditionElements}
            </React.Fragment>
        );
    }

}

CustomerConditionComponent.defaultProps = {
    errors: []
}

export default CustomerConditionComponent;
